<template>
    <section v-if="hasPermissions(['QC-Inspection-Surveys Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                In the survey question creation view, you can easily add new questions to your survey to gather valuable feedback from your audience. To create a new question, simply click the "Add Question" button and choose from a variety of response types such as multiple choice, free coment, and yes/no questions. 
            </p>
        </div>

        <div class="bar-container-inspections">
            <div class="bar-container-inspections__search-bar">
                <div class="input-field my-0" v-if="survey_questions.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container-inspections__options">
                <button v-if="hasPermissions(['QC-Inspection-Surveys Write'])" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div class="bar-container-inspections__cta">
                <div v-for="(val, i) in init_btn" :key="i">
                    <span v-if="hasPermissions(['QC-Inspection-Surveys Write'])" class="button__modal mr-3 text-md-right">
                        <a href="#" @click="form_modal(val.modal_name)" class="d-inline-md-block">
                            {{ val.name }}
                            <i class="prefix ml-1">
                                <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                            </i>
                        </a>
                    </span>
                </div>
            </div>
        </div>

        <div class="tab-content" v-show="survey_questions.length">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-12">
                        <div class="table-responsive table-fix-head" :style="`max-height: 35rem`">
                            <table>
                                <thead>
                                    <tr>
                                        <th slot="header" scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`theadcheck`" v-model="select_all" type="checkbox" class="custom-control-input" @change="selectAll()"/>
                                                <label :for="`theadcheck`" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                        <th scope="col" class="header-item">
                                            <span style="margin-left: 5px;" v-html="'Detail'"/>
                                                <!-- <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                            </span> -->
                                        </th>
                                        <th scope="col" v-for="(val, i) in table_headers" :key="i" v-html="val.text" />
                                    </tr>
                                </thead>
                                <draggable v-model="survey_questions" tag="tbody" @start="drag=true" @end="drag=false" @change="updateOrd(survey_questions)">
                                    <tr v-for="(val, i) in survey_questions" :key="i" :class="val.status ? 'table-primary' : ''">
                                        <td scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="val.checked" :disabled="select_all"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td scope="col">
                                            <a 
                                                class="bold-text"
                                                style="color: #039be5; text-decoration: none;"
                                                @click="modal_update(i)"
                                            >
                                                <span style="margin-left: 5px;">
                                                    <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                                </span>
                                            </a>
                                        </td>
                                        <th scope="row" v-html="(i+1)"/>
                                        <td v-html="val.question"/>
                                        <td v-html="`${val.question_type}`"/>
                                        <td v-html="`${format_response(val.response_type)}`"/>
                                        <!-- <td v-html="val.answer_1"/>
                                        <td v-html="val.answer_2"/>
                                        <td v-html="val.answer_3"/>
                                        <td v-html="val.answer_4"/>
                                        <td v-html="val.answer_5"/> -->
                                        <td>
                                            <div class="mb-0 form-group">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" v-model="val.status" :id="`switch${i}`" @change="status_upgrade(i, val.status)" :disabled="!hasPermissions(['QC-Inspection-Surveys Write'])">
                                                    <label class="custom-control-label" :for="`switch${i}`"/>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api_child, $event)"
        />

        <DeletionMassiveModal
          @objectDeletion="massive_local_emition($event)"
        />

        <SendSurveyFormModal 
            :parent="parent"
            :title="'Send Survey'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="sendSurvey_rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            ref="send_survey_modal"
        />

        <FormModal 
            :title="'New Question'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_child"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Question Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_child"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

    </section>
</template>

<script>

import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './detail_resources'
import FormModal            from    './FormModal'
import SendSurveyFormModal  from    './SendSurveyFormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import draggable            from    'vuedraggable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "SurveyQuestion",

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        draggable,
        SendSurveyFormModal,
        DeletionMassiveModal,
    },

    data() {
        return {
            notyf,
            axios,
            room_qc_inventory_id:   this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            crypt_parent_id:        this.$route.params.id,
            title_page:             'Survey Questions',
            content_header:         this.$store.state.headers,
            rest_api:               `surveys/${this.$route.params.id}`,
            rest_api_child:         `survey_questions`,
            sendSurvey_rest_api:    `survey_mails`,
            notifications:          this.$store.state.form_notyf,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            init_btn:[
                {
                    name:       'Send Survey',
                    modal_name: 'static-survey',
                },
                {
                    name:       'Add Question',
                    modal_name: 'static',
                }
            ],
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            survey_questions:       [],
            array_options:          {},
            select_all:             false,
            select_ids:             [],
        }
    },

    methods: {

        async updateOrd(data)
        {
            await this.postingByPost('post_dragging', data)
        },

        format_question(question_type)
        {   
            let question = this.array_options.question_type.find(item => item.id === question_type)
            return question.name
        },

        format_response(response_type)
        {
            return response_type ? this.array_options.response_type.find(item => item.id === response_type).name : 'Undefined'
        },

        unshift_object(new_object)
        {
            this.survey_questions.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.survey_questions.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        status_upgrade(index, value)
        {
            this.survey_questions.map((item, i) => {
                if(i === index){
                    item.status = value
                }
            })
            this.status_update(this.survey_questions[index].id, this.survey_questions[index], index, this.rest_api_child)
        },

        form_modal(modal_name)
        {
            window.$(`#${modal_name}`).modal('show')

            if(modal_name == 'static-survey')
            {
                this.$refs.send_survey_modal.initiate(this.parent.subject, this.parent.email_body)
            }
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.survey_questions[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.survey_questions[index]
            this.single_object.updated_date = this.date;
            
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.parent             = data.parent
            this.parent_id          = data.parent_id
            this.survey_questions   = data.survey_questions
            this.array_options      = {
                step_code_id: data.step_codes,
                question_type_id: data.question_types,
                response_type: Resources.response_types,
                cost_center_id: data.cost_centers,
                cost_center_department_id: [],
            }
            this.breadcrumb.push({
                name:   this.parent.name,
                href:   '#',
                arrow:  "",
            })
        },

        trashing(index)
        {
            this.survey_questions.splice(index, 1)
        },

        selectAll()
        {
            this.survey_questions.map(item => item.checked = this.select_all)
        },

        massive_modal_delete()
        {
            this.select_ids = this.survey_questions.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }
            const temp_rest_api = this.rest_api
            this.rest_api = this.rest_api_child
            let sendingMassive = await this.massive_delete(json_request)
            this.rest_api = temp_rest_api

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                const index = this.survey_questions.findIndex(value => value.id == item)
                if(index > -1)
                {
                    this.survey_questions.splice(index, 1)
                }
                })
                this.select_ids = []
            }
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection-Surveys Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.survey_questions.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
};
</script>
